import React from 'react';
import { Button } from 'react-bootstrap';
import PropdocsModal from '../../modal/PropdocsModal';
import { ReactComponent as DocumentIcon } from '../../../shared/icons/document-icon.svg';
import { ChatSession } from '../AiChatSlideout';
import styles from './DeleteChatConfirmationModal.module.scss';

interface DeleteChatConfirmationModalProps {
  session: ChatSession | null;
  onConfirm: () => void;
  onCancel: () => void;
  isDeleting: boolean;
}

export const DeleteChatConfirmationModal: React.FC<DeleteChatConfirmationModalProps> = ({
  session,
  onConfirm,
  onCancel,
  isDeleting,
}) => {
  return (
    <PropdocsModal
      show={!!session}
      setShow={onCancel}
      title={<>Delete Chat?</>}
      size="md"
    >
      <div className="confirmation-modal-content">
        <div className="confirmation-modal-body">
          <p>Are you sure you want to delete this chat? This action cannot be undone.</p>
          {session?.documentName && (
            <div className={styles.documentInfo}>
              <DocumentIcon />
              <span>{session.documentName}</span>
            </div>
          )}
        </div>
        <div className="confirmation-modal-actions">
          <Button 
            variant="link" 
            className="text-secondary" 
            onClick={onCancel}
            disabled={isDeleting}
          >
            Cancel
          </Button>
          <Button 
            variant="danger" 
            onClick={onConfirm}
            disabled={isDeleting}
          >
            {isDeleting ? 'Deleting...' : 'Delete'}
          </Button>
        </div>
      </div>
    </PropdocsModal>
  );
};
